import React from 'react';
import SelectQuestion from 'pages/admin/interview_sheet/questions/SelectQuestion';

const MultipleSelectQuestion = props => {
    return <SelectQuestion isMultiple={true} {...props} />;
};

export default MultipleSelectQuestion;
